import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocDetalle } from './DocDetalle';
import { storeFile, deleteFile  } from '../../utils/indexedDB';
import { getFileSize } from '../../utils/indexedDB';

export const CargaDocumentos = ({ setCanSign, setErrorMessageKey, setFileName  }) => {
    const { t } = useTranslation();
    const [file, setFile] = useState(null);
    const [isDragOver, setIsDragOver] = useState(false);

    const handleFileChange = (e) => {
        const uploadedFile = e.target.files[0];
        e.target.value = '';
        validateAndSetFile(uploadedFile);
    };

    const handleDeleteFile = () => {
        if (file) {
            deleteFile(file.name).then(() => {
                setFile(null);
                setCanSign(false);
                setErrorMessageKey('');
                setFileName('');
            });
        }
        setFile(null);
    };

    const getFileSize = (size) => {
        const kbSize = (size / 1024).toFixed(2);
        return `${kbSize} kb`;
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const uploadedFile = e.dataTransfer.files[0];
        validateAndSetFile(uploadedFile);
    };

    const validateAndSetFile = (uploadedFile) => {
        if (uploadedFile && uploadedFile.type === 'application/pdf') {
            const reader = new FileReader();
            reader.onload = () => {
                const fileData = reader.result.split(',')[1]; // Remove the base64 prefix
                storeFile(uploadedFile.name, fileData).then(() => {
                    setFile(uploadedFile);
                    setCanSign(true);
                    setErrorMessageKey('');
                    setFileName(uploadedFile.name);
                    localStorage.setItem('fileName', uploadedFile.name);
                });
            };
            reader.readAsDataURL(uploadedFile);
        } else {
            setErrorMessageKey('cargaDocumentos.invalidFileType');
        }
    };
    return (
        <div className="component-carga-documentos">
            <div
                className={`carga-documento-content ${file ? 'carga-documento-content-disabled' : ''} ${isDragOver ? 'drag-over' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <span className="material-symbols-outlined">cloud_upload</span>
                <p className="text">{t('cargaDocumentos.dragAndDrop')}</p>
                <p className="text-small">{t('cargaDocumentos.or')}</p>

                <input
                    className="file-upload-input"
                    type="file"
                    onChange={handleFileChange}
                    disabled={!!file}
                />

                <button
                    className="local-upload btn-medium btn-primary-outline"
                    type="button"
                    data-toggle="tooltip"
                    data-placement="top"
                    title={t('cargaDocumentos.selectFile')}
                    onClick={() => {
                        document.querySelector('.file-upload-input').click();
                    }}
                >
                    {t('cargaDocumentos.selectFileFromDevice')}
                </button>

                <p className="text-alert">{t('cargaDocumentos.fileAlert')}</p>

                {file && (
                    <DocDetalle
                        fileName={file.name}
                        fileSize={getFileSize(file.size)}
                        onDelete={handleDeleteFile}
                    />
                )}
            </div>
        </div>
    );
};
